import { CircleStatus } from "./style";

interface IProps {
  status: 0 | 1 | 2 | 3 | 4;
}

const strategy: Record<number, { cor: string; label: string }> = {
  0: { cor: "#888888", label: "Pré cadastro" },
  1: { cor: "#f8ac59", label: "Em andamento" },
  2: { cor: "#ed5565", label: "Pendente" },
  3: { cor: "#23c6c8", label: "Finalizado" },
  4: { cor: "#333333", label: "Cancelado" },
};

export function StatusProcesso({ status }: IProps) {
  const config = strategy[status] ?? strategy[0];
  return <CircleStatus color={config.cor} title={config.label} />;
}
